import { useEffect } from 'react'
import type { Controls } from '~/api/endpoints/getControls'
import { useStore } from './useStore'

/** Sets the global model floor from get_controls (model_period_min) when controls load.
 *  Mount once where controls are available (ReviewPageScaffold). */
export function useSyncModelFloor(controls: Controls | undefined): void {
  const setModelFloorIso = useStore((s) => s.system.setModelFloorIso)
  const floor = controls?.min_max_dates.model_period_min ?? null
  useEffect(() => {
    if (floor) setModelFloorIso(floor)
  }, [floor, setModelFloorIso])
}
